import { Button, CircularProgress, Stack, SvgIcon, Typography } from "@mui/material";
import { FC, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useRolesList } from "../presenters/useRolesList";
import { tokens } from "../../../../locales/tokens";
import AddIcon from '@mui/icons-material/Add';
import { getStyles } from "./styles";
import { Link } from "react-router-dom";
import { paths } from "../../../../paths";
import { RolesTable } from "./components/rolesTable";
import { TabSelector } from "../../../../ui-kit/tabSelector/tabSelector";

export const RolesList: FC = () => {
    const { t } = useTranslation();
    const styles = useMemo(() => getStyles(), []);
    const { activeTab, roles, isRoleLoading, onToggleTab, onDeleteRole } = useRolesList();

    const tabOptions = [
        { label: t(tokens.common.activeTab), value: "ACTIVE" },
        { label: t(tokens.common.archiveTab), value: "ARCHIVE" },
    ];

    return (
        <Stack m={2}>
            <Stack direction='row' justifyContent='space-between'>
                <Typography variant="h5" fontWeight={600}>{t(tokens.roles.title.rolesList)}</Typography>
                <Button
                    startIcon={(<SvgIcon><AddIcon /></SvgIcon>)}
                    variant="contained"
                    sx={styles.createBtn}
                    component={Link}
                    to={paths.dashboard.users.rolesCreate}
                >
                    {t(tokens.common.create)}
                </Button>
            </Stack>
            <Stack mt={1}><TabSelector tab={activeTab} tabOptions={tabOptions} handleTabsChange={onToggleTab} /></Stack>
            {isRoleLoading && !roles.length
                ? <Stack
                    direction="row"
                    justifyContent="center"
                    alignItems="center"
                    sx={styles.progressWrapper}
                >
                    <CircularProgress color="primary" />
                </Stack>
                : <RolesTable roles={roles} onDelete={onDeleteRole} />
            }
        </Stack>
    )
};